/**
 * TP Cart UI — enda platsen som svarar på "lagd i varukorgen".
 *
 * BAKGRUND (audit 2026-09):
 * Temat hade tre parallella bekräftelse-system: Dawns cart-notification
 * (laddades på varje sida men renderades aldrig), cart-drawer, och en egen
 * tp-added-modal. Vilket som visades berodde på vilken köpyta som råkade
 * äga klicket.
 *
 * NU: en lyssnare på tp:cart:added. Desktop öppnar cart-drawer.
 * Mobil öppnar bekräftelsepanelen (snippets/tp-cart-confirm.liquid).
 * Ingen annan fil får öppna en köpbekräftelse.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE).matches;
  }

  function config() {
    return window.tpCartConfig || {};
  }

  function money(cents) {
    var value = Number(cents || 0) / 100;
    var formatted = value.toLocaleString('sv-SE', {
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
    return formatted + ' kr';
  }

  /* ------------------------------------------------------------------
     Cart-bubblan och drawern hålls i synk från EN plats.
  ------------------------------------------------------------------ */
  function updateBubble(cart) {
    if (!cart) return;
    var count = Number(cart.item_count || 0);
    document.querySelectorAll('#cart-icon-bubble, [data-tp-cart-count]').forEach(function (node) {
      /* Samma markup som sections/cart-icon-bubble.liquid: ingen bubbla alls
         när korgen är tom (annars stod en nolla kvar på ikonen), annars
         siffran och antalet för skärmläsare. Ikonens egen etikett
         ("Varukorg") före bubblan ska stå kvar. */
      var bubble = node.querySelector('.cart-count-bubble');
      if (count === 0) {
        if (bubble) bubble.remove();
        bubble = null;
      } else if (!bubble && node.id === 'cart-icon-bubble') {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
        node.appendChild(bubble);
      }
      var visible = node.querySelector('[data-tp-cart-count-value]') ||
        (bubble ? bubble.querySelector('span[aria-hidden="true"]') : null);
      if (visible) visible.textContent = String(count);
      var sr = bubble ? bubble.querySelector('.visually-hidden') : null;
      if (sr) sr.textContent = count === 1 ? '1 artikel' : count + ' artiklar';
      node.classList.toggle('tp-cart-empty', count === 0);
      node.setAttribute('data-cart-count', String(count));
    });
  }

  function renderSections(sections) {
    if (!sections) return false;

    var drawer = document.querySelector('cart-drawer');

    /* Dawns egen renderContents används när den finns. Den binder om
       overlay-klicket och nollställer is-empty. Att i stället sätta
       innerHTML direkt tappar overlay-lyssnaren, så drawern gick inte
       att stänga genom att klicka utanför. */
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections: sections });
      return true;
    }

    var rendered = false;

    if (sections['cart-drawer']) {
      var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var freshInner = parsed.querySelector('#CartDrawer');
      var currentInner = document.querySelector('#CartDrawer');
      if (freshInner && currentInner) {
        currentInner.innerHTML = freshInner.innerHTML;
        var overlay = currentInner.querySelector('#CartDrawer-Overlay');
        if (overlay && drawer && typeof drawer.close === 'function') {
          overlay.addEventListener('click', drawer.close.bind(drawer));
        }
        rendered = true;
      }
      var freshHost = parsed.querySelector('cart-drawer');
      if (freshHost && drawer) {
        drawer.classList.toggle('is-empty', freshHost.classList.contains('is-empty'));
      }
    }

    if (sections['cart-icon-bubble']) {
      var bubbleHost = document.querySelector('#cart-icon-bubble');
      if (bubbleHost) {
        var wrap = document.createElement('div');
        wrap.innerHTML = sections['cart-icon-bubble'];
        var fresh = wrap.querySelector('#cart-icon-bubble') || wrap.firstElementChild;
        if (fresh) bubbleHost.innerHTML = fresh.innerHTML;
      }
    }

    return rendered;
  }

  function refreshDrawerFromNetwork() {
    return fetch('/?sections=cart-drawer', { cache: 'no-store' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (sections) {
        if (sections) renderSections(sections);
      })
      .catch(function () {});
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    if (typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    drawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
    return true;
  }

  /* ------------------------------------------------------------------
     Mobil bekräftelsepanel. Markup kommer från
     snippets/tp-cart-confirm.liquid — inte från en JS-sträng, så texterna
     går att ändra utan att röra JavaScript.
  ------------------------------------------------------------------ */
  var lastFocus = null;

  function panel() {
    return document.querySelector('[data-tp-cart-confirm]');
  }

  /* options.quiet: ett annat lager tar över och flyttar själv fokus. */
  function closeConfirm(options) {
    var node = panel();
    if (!node) return;
    node.classList.remove('is-open');
    node.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('tp-cart-layer-open');
    if (!(options && options.quiet) && lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
    lastFocus = null;
  }

  /* Ett lager åt gången (P2-01). */
  document.addEventListener('tp:layer-open', function (event) {
    var node = panel();
    if (event.detail && event.detail.name !== 'cart-confirm' && node && node.classList.contains('is-open')) {
      closeConfirm({ quiet: true });
    }
  });

  function shippingMessage(cart) {
    var threshold = Number(config().freeShippingThreshold || 0);
    var strings = config().strings || {};
    if (threshold <= 0) return strings.shippingAlwaysFree || '';
    var total = Number((cart && cart.total_price) || 0);
    if (total >= threshold) return strings.shippingReached || 'Du har fri frakt!';
    var remaining = threshold - total;
    return (strings.shippingRemaining || '{amount} kvar till fri frakt').replace('{amount}', money(remaining));
  }

  /* Egen mix (PXL, 2026-10): raderna från samma mix bär samma _tp_mix och
     visas som ETT paket i bekräftelsen — mixens namn ("Del av"), smakerna
     på en rad och mixens totalpris — i stället för första sexpacket och
     "+ 3 till i varukorgen". */
  function mixOf(items) {
    if (!items || items.length < 2) return null;
    var key = items[0].properties && items[0].properties._tp_mix;
    if (!key) return null;
    for (var i = 1; i < items.length; i++) {
      if (!items[i].properties || items[i].properties._tp_mix !== key) return null;
    }
    var total = 0;
    var original = 0;
    var names = [];
    items.forEach(function (it) {
      total += Number(it.final_line_price != null ? it.final_line_price : it.price || 0);
      original += Number(it.original_line_price || 0);
      var name = String(it.variant_title || '').replace(/\s*\(.*\)\s*$/, '');
      if (name) names.push(name);
    });
    return {
      title: items[0].properties['Del av'] || items[0].product_title || '',
      flavours: names.join(', '),
      total: total,
      original: original
    };
  }

  function fillConfirm(node, detail) {
    var item = (detail.items && detail.items[0]) || null;
    if (!item) return;
    var mix = mixOf(detail.items);

    var img = node.querySelector('[data-tp-confirm-image]');
    if (img) {
      var src = item.image || item.featured_image?.url || '';
      if (src) {
        img.src = src;
        img.alt = item.product_title || item.title || '';
        img.hidden = false;
      } else {
        img.removeAttribute('src');
        img.hidden = true;
      }
    }

    var title = node.querySelector('[data-tp-confirm-title]');
    if (title) title.textContent = mix ? mix.title : item.product_title || item.title || '';

    var variant = node.querySelector('[data-tp-confirm-variant]');
    if (variant) {
      var label = mix ? mix.flavours : item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      variant.textContent = label;
      variant.hidden = !label;
    }

    var price = node.querySelector('[data-tp-confirm-price]');
    if (price) price.textContent = money(mix ? mix.total : item.final_line_price != null ? item.final_line_price : item.price);

    var compare = node.querySelector('[data-tp-confirm-compare]');
    var saving = node.querySelector('[data-tp-confirm-saving]');
    var original = mix ? mix.original : Number(item.original_line_price || 0);
    var final = mix ? mix.total : Number(item.final_line_price != null ? item.final_line_price : item.price || 0);
    /* Prenumerationsrad: radens pris är redan prenumerationspriset, så
       ordinarie pris står i allokeringens compare_at_price. */
    var plan = item.selling_plan_allocation;
    if (plan && plan.compare_at_price) {
      original = Math.max(original, Number(plan.compare_at_price) * Number(item.quantity || 1));
    }
    var onSale = original > final;
    if (compare) {
      compare.hidden = !onSale;
      compare.textContent = onSale ? money(original) : '';
    }
    if (saving) {
      saving.hidden = !onSale;
      saving.textContent = onSale
        ? ((config().strings || {}).saving || 'Du sparar {amount}').replace('{amount}', money(original - final))
        : '';
    }

    var extra = node.querySelector('[data-tp-confirm-extra]');
    if (extra) {
      var more = mix ? 0 : (detail.items || []).length - 1;
      extra.hidden = more < 1;
      extra.textContent = more > 0
        ? ((config().strings || {}).alsoAdded || '+ {count} till i varukorgen').replace('{count}', more)
        : '';
    }

    var shipping = node.querySelector('[data-tp-confirm-shipping]');
    if (shipping) {
      var msg = shippingMessage(detail.cart);
      shipping.textContent = msg;
      shipping.hidden = !msg;
    }

    var count = node.querySelector('[data-tp-confirm-count]');
    if (count && detail.cart) {
      count.textContent = ((config().strings || {}).cartCount || 'Varukorg ({count})')
        .replace('{count}', Number(detail.cart.item_count || 0));
    }

    fillSubscription(node, activeChoice(detail) ? null : item);
  }

  /* Har kunden redan valt mellan engångsköp och prenumeration? Då ska
     bekräftelsen inte fråga igen (P2-03). Valet fanns om köpet kom från en
     köpyta med prenumerationsvalet (.tp-sub-ui, produktsidan och dess fasta
     köprad) eller från snabbköpet, som har en egen växel. */
  function activeChoice(detail) {
    var trigger = detail && detail.trigger;
    if (!trigger || typeof trigger.closest !== 'function') return false;
    if (trigger.closest('.tp-qa, [data-tp-qa]')) return true;
    var scope = trigger.closest('.tp2[data-section]') || trigger.closest('form');
    return !!(scope && scope.querySelector('.tp-sub-ui [data-tp-one-time]'));
  }

  /* ------------------------------------------------------------------
     Prenumeration i bekräftelsen. Ingen egen logik här: luckan har
     redan renderat radens block (snippets/tp-cart-sub-offer) med
     Shopifys planer och priser, och skriptet i cart-drawer.liquid gör
     bytet. Bekräftelsen visar en kopia av just den radens block.
  ------------------------------------------------------------------ */
  function fillSubscription(node, item) {
    var slot = node.querySelector('[data-tp-confirm-sub]');
    if (!slot) return;
    slot.innerHTML = '';
    slot.hidden = true;
    if (!item || !item.key) return;

    var source = null;
    document.querySelectorAll('#CartDrawer [data-tp-sub]').forEach(function (box) {
      if (box.getAttribute('data-line-key') === String(item.key)) source = box;
    });
    if (!source) return;

    var copy = source.cloneNode(true);
    copy.querySelectorAll('[id]').forEach(function (el) {
      el.removeAttribute('id');
    });
    slot.appendChild(copy);
    slot.hidden = false;
  }

  function openConfirm(detail) {
    var node = panel();
    if (!node) return false;

    lastFocus = (detail && detail.trigger) || document.activeElement;
    fillConfirm(node, detail);

    node.classList.add('is-open');
    node.setAttribute('aria-hidden', 'false');
    document.body.classList.add('tp-cart-layer-open');
    document.dispatchEvent(new CustomEvent('tp:layer-open', { detail: { name: 'cart-confirm' } }));

    window.setTimeout(function () {
      var focusTarget = node.querySelector('[data-tp-confirm-continue]') || node.querySelector('[data-tp-confirm-close]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }, 60);

    return true;
  }

  /* Stäng: klick på close/backdrop, Escape. En lyssnare vardera. */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-tp-confirm-close], [data-tp-confirm-continue], [data-tp-confirm-backdrop]')) {
      closeConfirm();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var node = panel();
    if (node && node.classList.contains('is-open')) closeConfirm();
  });

  /* Fokusfälla i bekräftelsepanelen. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var node = panel();
    if (!node || !node.classList.contains('is-open')) return;
    var focusable = node.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ------------------------------------------------------------------
     Enda reaktionen på ett lyckat köp.
  ------------------------------------------------------------------ */
  document.addEventListener('tp:cart:added', function (event) {
    var detail = event.detail || {};

    updateBubble(detail.cart);

    var didRender = renderSections(detail.sections);
    var ready = didRender ? Promise.resolve() : refreshDrawerFromNetwork();

    ready.then(function () {
      /* Ångra i varukorgsluckan: luckan är redan öppen och har just ritats
         om. Ingen köpbekräftelse ovanpå den. */
      if (detail.source === 'cart-undo') return;
      if (isMobile() && panel()) {
        openConfirm(detail);
      } else if (!openDrawer()) {
        openConfirm(detail);
      }
    });
  });

  document.addEventListener('tp:cart:updated', function (event) {
    updateBubble(event.detail && event.detail.cart);
  });

  /* En rad har bytts mellan engångsköp och prenumeration (cart-drawer.liquid).
     Är bekräftelsen öppen visar den nu raden som den ser ut efter bytet. */
  document.addEventListener('tp:cart:line-changed', function (event) {
    var detail = event.detail || {};
    updateBubble(detail.cart);
    var node = panel();
    if (!node || !node.classList.contains('is-open') || !detail.line) return;
    fillConfirm(node, { items: [detail.line], cart: detail.cart });
    var next = node.querySelector('[data-tp-confirm-sub] button:not([hidden])') ||
      node.querySelector('[data-tp-confirm-continue]');
    if (next) next.focus({ preventScroll: true });
  });

  /* ------------------------------------------------------------------
     Fel: visa inline där köpet skedde, annars en diskret statusrad.
     Aldrig alert() — det fanns på fyra ställen tidigare.
  ------------------------------------------------------------------ */
  document.addEventListener('tp:cart:error', function (event) {
    var detail = event.detail || {};
    var trigger = detail.trigger;
    var inline = trigger && trigger.closest
      ? trigger.closest('[data-tp-purchase-scope], product-form, form')
      : null;
    var target = inline ? inline.querySelector('[data-tp-cart-error]') : null;

    if (target) {
      target.textContent = detail.message;
      target.hidden = false;
      window.setTimeout(function () {
        target.hidden = true;
      }, 6000);
      return;
    }

    var live = document.querySelector('[data-tp-cart-live]');
    if (live) {
      live.textContent = detail.message;
      window.setTimeout(function () {
        live.textContent = '';
      }, 6000);
    } else if (window.console) {
      console.warn('TPCart:', detail.message);
    }
  });

  /* ------------------------------------------------------------------
     Drawern far inte visa ett gammalt varukorgslage.

     Rapporterat fel: bubblan visar tva varor, men lada man oppnar sager
     "Din varukorg ar tom". Drawerns markup renderas av servern nar sidan
     laddas och rors sedan bara vid ett kop pa just den sidan. Kommer man
     till sidan fran cache — bakatknappen, bfcache, en sida Shopify hunnit
     cacha — sitter den gamla, tomma markupen kvar medan bubblan raknas
     upp av JS. Innehallet och siffran beskriver da tva olika varukorgar.

     Losningen ar inte ett nytt renderingssystem: refreshDrawerFromNetwork
     finns redan och anvands vid kop. Den kors nu ocksa precis innan lada
     oppnas, och nar sidan visas igen fran cache.
  ------------------------------------------------------------------ */
  var lastDrawerSync = 0;

  function syncDrawer(force) {
    var now = Date.now();
    if (!force && now - lastDrawerSync < 1500) return;
    lastDrawerSync = now;
    refreshDrawerFromNetwork();
  }

  /* Allt som oppnar lada: varukorgsikonen i headern, lankar till /cart
     som drawern fangar upp, och vara egna oppnare. Lyssnaren ar passiv —
     den avbryter ingenting och andrar inget flode. */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var opener = target.closest(
        '#cart-icon-bubble, .tp2-header__cart, [data-tp-cart-open], a[href$="/cart"], a[href*="/cart?"]'
      );
      if (!opener) return;
      if (!document.querySelector('cart-drawer')) return;
      syncDrawer(false);
    },
    true
  );

  /* Tillbaka till sidan fran webblasarens cache: bade siffran och
     innehallet kan vara fran ett tidigare varukorgslage. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (document.querySelector('cart-drawer')) syncDrawer(true);
    fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) { if (cart) updateBubble(cart); })
      .catch(function () {});
  });

  window.TPCartUI = {
    openConfirm: openConfirm,
    closeConfirm: closeConfirm,
    openDrawer: openDrawer,
    updateBubble: updateBubble,
    syncDrawer: syncDrawer
  };
})();
